const firebaseConfig = {
    apiKey: "AIzaSyBDMYMAXhqYDLJyQdcB_xGunEiJsO4mAkA",
    authDomain: "hungry-vai.firebaseapp.com",
    projectId: "hungry-vai",
    storageBucket: "hungry-vai.appspot.com",
    messagingSenderId: "351797251489",
    appId: "1:351797251489:web:6491f3f91e333f2e24cfe0"
  };

  export default firebaseConfig;